<template>
    <div id="pageTable">
        <v-overlay :value="overlayDesgarga">
            <div class="align-center justify-center text-center">
                <v-progress-circular
                    indeterminate
                    :size="100"
                    :width="7"
                    color="#2DB9D1"
                >
                    <v-img src="/static/icon/favicon.ico" :width="60"></v-img>
                </v-progress-circular>
                <p>{{ frase }}</p>
            </div>
        </v-overlay>
        <v-container grid-list-xl fluid>
            <v-row class="pa-0 mt-0 mb-0">
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="pa-0 ">
                    <div style="display: flex; width:100%; height:100%; justify-content: flex-start;">
                        <hr class="vr"/>
                        <p class="tblName pb-2">Lotes</p>
                    </div>
                </v-col>

            </v-row>
            <v-row class="mt-6">
                <v-col cols="12" xs="12" sm="12" md="12" class="div-card py-8" >
                    <div  style="overflow-x: auto;">
                        <v-row class="py-0 my-0 mt-5 mx-3">
                            <v-col  v-if="rol == 'root'" cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="clientes"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Cliente"
                                    persistent-hint
                                    v-model="cliente_value"
                                    no-data-text="Datos no disponibles"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="itemsRegistrosPatronales"
                                    item-text="nombreClave"
                                    item-value="id"
                                    label="Registro patronal"
                                    persistent-hint
                                    v-model="registro_patronal_value"
                                    no-data-text="Datos no disponibles"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="itemsLotes"
                                    item-text="loteFecha"
                                    item-value="id"
                                    label="Lote"
                                    persistent-hint
                                    v-model="lote_value"
                                    no-data-text="Datos no disponibles"
                                >
                                    <template slot="append-item">
                                        <div class="text-center">
                                            <v-btn
                                                v-if="itemsLotes.length >= 10"
                                                @click="getLotes(Math.trunc(itemsLotes.length/10 + 1))"
                                                class="btnNormalClaro mx-3 my-3"
                                            >
                                                Obtener mas...<v-icon>autorenew</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>


                        </v-row>

                        <v-row class="py-0 my-0 d-flex justify-end mx-6">
                            <v-btn
                                elevation="0"
                                class="btnNormalClaro"
                                @click="lote_value != null ? obtenerDatos() : ''"
                            >
                                Obtener datos
                            </v-btn>
                        </v-row>

                        <template v-if="showTabla">




                            <v-row class="pa-0 ma-0 mx-6 mt-5" >
                                <v-col cols="12" xs="12" sm="12" md="12" class="px-5 py-2 border-tabla1" style="min-width: 700px;">
                                    <table class="tbl-collapse ">
                                        <thead>
                                            <tr class="pa-0 ma-0">
                                                <th width="25%" class="tbl1-title pt-3">
                                                    Lote
                                                </th>
                                                <th width="25%" class="border-left tbl1-title pl-2 pt-3">
                                                    R.F.C.
                                                </th>
                                                <th width="25%" class="border-left tbl1-title pl-2 pt-3">
                                                    Registro Patronal
                                                </th>
                                                <th width="25%" class="border-left tbl1-title pl-2 pt-3">
                                                    Fecha de envío
                                                </th>
                                            </tr>
                                            <tr class="pa-0 ma-0">
                                                <th class="tbl1-subtitle pb-3">
                                                    {{ datosLote.numero_lote }}
                                                </th>
                                                <th class="border-left tbl1-subtitle pl-2 pb-3">
                                                    {{ datosRegistroPatronal.rfc }}
                                                </th>
                                                <th class="border-left tbl1-subtitle pl-2 pb-3">
                                                    {{ datosRegistroPatronal.nombre }}
                                                </th>
                                                <th class="border-left tbl1-subtitle pl-2 pb-3">
                                                    {{ dateFormat(datosLote.fecha)  }}
                                                </th>
                                            </tr>
                                        </thead>
                                    </table>
                                </v-col>
                            </v-row>

                            <v-row class="pa-0 ma-0 mt-6">
                                <v-col cols="12" xs="12" sm="12" md="12" class="px-5 py-2 border-tabla2" style="min-width: 700px;">
                                    <table class="tbl-collapse tbl2">
                                        <thead>
                                            <tr class="pa-0 ma-0">
                                                <th colspan="3" class="tbl2-title py-2" style="border-top-left-radius: 15px; border-bottom: 1px solid #E0E0E0;">
                                                    Reingresos
                                                </th>
                                                <th colspan="3" class="tbl2-title py-2 border-left " style="border-bottom: 1px solid #E0E0E0;">
                                                    Bajas
                                                </th>
                                                <th colspan="3" class="tbl2-title py-2 border-left" style="border-bottom: 1px solid #E0E0E0;">
                                                    Modificación de salario
                                                </th>
                                                <th colspan="3" class="tbl2-title py-2 border-left" style="border-top-right-radius: 15px; border-bottom: 1px solid #E0E0E0;">
                                                    Opciones
                                                </th>

                                            </tr>
                                            <tr class="pa-0 ma-0">
                                                <th class="tbl2-subtitle">
                                                    Operados
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Rechazados
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Total
                                                </th>
                                                <!-- *********** -->

                                                <th class="tbl2-subtitle border-left">
                                                    Operados
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Rechazados
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Total
                                                </th>
                                                <!-- ********** -->

                                                <th class="tbl2-subtitle border-left">
                                                    Operados
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Rechazados
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Total
                                                </th>
                                                 <!-- ********** -->

                                                <th class="tbl2-subtitle border-left">
                                                    Acuse de recibido
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Acuse de respuesta
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Excel
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.reingresos_aceptados }}</td>
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.reingresos_rechazados }}</td>
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.reingresos_totales }}</td>
                                                <!-- *********** -->
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.bajas_aceptados }}</td>
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.bajas_rechazados }}</td>
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.bajas_totales }}</td>
                                                <!-- ********** -->
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.mod_salario_aceptados }}</td>
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.mod_salario_rechazados }}</td>
                                                <td class="text-center py-2 tbl2-data">{{ datosLote.mod_salario_totales }}</td>
                                                <!-- ********** -->
                                                <td class="text-center py-2 tbl2-data">
                                                    <v-btn
                                                        class="ma-2"
                                                        text
                                                        icon
                                                        color="#5C5C5C"
                                                        @click="descarga('ACUSE_RECIBIDO')"
                                                    >
                                                        <v-icon size="28">inbox</v-icon>
                                                    </v-btn>
                                                </td>
                                                <td class="text-center py-2 tbl2-data">
                                                    <v-btn
                                                        class="ma-2"
                                                        text
                                                        icon
                                                        color="#5C5C5C"
                                                        @click="descarga('ACUSE_ACEPTADO')"
                                                        v-if="datosLote.url_acuse == null ? false : true"
                                                    >
                                                        <v-icon size="28">check_circle_outline</v-icon>
                                                    </v-btn>
                                                </td>
                                                <td class="text-center py-2 tbl2-data">
                                                    <v-btn
                                                        class="ma-2"
                                                        text
                                                        icon
                                                        color="#5C5C5C"
                                                        @click="descarga('EXCEL')"
                                                        v-if="datosLote.url_acuse == null ? false : true"
                                                    >
                                                        <v-img
                                                            src="/static/svg/xls.svg"
                                                            width="24"
                                                            height="24"
                                                            class="mx-1 xls-icon"
                                                        ></v-img>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-col>
                            </v-row>

                            <v-row class="py-0 my-0 mt-15 mx-6" style="min-width: 700px;">
                                <div
                                    class="btn-lotes mr-2 d-flex justify-center align-center"
                                    :class="btnLotes == 'btn1' ? 'btn-activo':'btn-inactivo'"
                                    @click="filtroLotes('btn1')"
                                >
                                    <span class="ma-3">Todos los registros</span>
                                </div>
                                <div
                                    class="btn-lotes mr-2 d-flex justify-center align-center"
                                    :class="btnLotes == 'btn2' ? 'btn-activo':'btn-inactivo'"
                                    @click="filtroLotes('btn2')"
                                >
                                    <span class="ma-3">Operados</span> <!-- empleados con  item.estado == 'PROCESADO'-->
                                </div>
                                <div
                                    class="btn-lotes mr-2 d-flex justify-center align-center"
                                    :class="btnLotes == 'btn3' ? 'btn-activo':'btn-inactivo'"
                                    @click="filtroLotes('btn3')"
                                >
                                    <span class="ma-3">Rechazados</span>
                                </div>
                                <!-- <div
                                    class="btn-lotes mr-2 d-flex justify-center align-center"
                                    :class="btnLotes == 'btn4' ? 'btn-activo':'btn-inactivo'"
                                    @click="filtroLotes('btn4')"
                                >
                                    <span class="ma-3">Enviados</span>
                                </div> -->
                            </v-row>

                            <v-row class="pa-0 ma-0 mt-6">

                                <v-col
                                    cols="12" xs="12" sm="12" md="12"
                                    class="px-5 py-2 border-tabla2"
                                    style="min-width: 700px;"
                                    v-if="showTable == 'todos' || showTable == 'aceptados'"
                                >
                                    <table class="tbl-collapse tbl2">
                                        <thead>
                                            <tr class="pa-0 ma-0">
                                                <th colspan="13" class="tbl2-title py-2" style="border-top-left-radius: 15px; border-top-right-radius: 15px; border-bottom: 1px solid #E0E0E0;">
                                                    Movimientos operados
                                                </th>
                                            </tr>
                                            <tr class="pa-0 ma-0">
                                                <th class="tbl2-subtitle">
                                                    #T.Mov.
                                                </th>
                                                <th class="tbl2-subtitle text-left">
                                                    NSS
                                                </th>
                                                <th class="tbl2-subtitle text-left">
                                                    Nombre
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Salario SBC
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Ext.
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    UMF
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Fecha Mov.
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    T. Salario
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    T. Jornada
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    T. Trabajador
                                                </th>
                                                <th class="tbl2-subtitle text-left">
                                                    CURP
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    C. Baja
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="itemsMovimientosAceptados.length == 0">
                                                <tr>
                                                    <td colspan="13" class="text-center py-5 tbl2-data">No hay datos disponibles</td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr :key="item.id" v-for="item in itemsMovimientosAceptados">
                                                    <td class="text-center py-2 tbl2-data">{{ item.tipo_movimiento_clave }}</td>
                                                    <td class="text-left py-2 tbl2-data">{{ item.nss }}</td>
                                                    <td class="text-left py-2 tbl2-data">{{ item.nombre + ' ' + item.apellido_paterno + ' ' + item.apellido_materno }}</td>
                                                    <td class="text-right py-2 tbl2-data">${{ item.sbc ? item.sbc : '---' }}</td>
                                                    <td class="text-center py-2 tbl2-data">{{ item.ext ? item.ext : '---' }}</td>
                                                    <td class="text-center py-2 tbl2-data">{{ item.umf ? item.umf : '---' }}</td>
                                                    <td class="text-center py-2 tbl2-data">{{ dateFormat(item.fecha_movimiento) }}</td>
                                                    <td class="text-center py-2 tbl2-data">{{ item.tipo_salario ? item.tipo_salario : '---' }}</td>
                                                    <td class="text-center py-2 tbl2-data">{{ item.jornada_reducida ? item.jornada_reducida : '---' }}</td>
                                                    <td class="text-center py-2 tbl2-data">{{ item.tipo_trabajador ? item.tipo_trabajador : '---' }}</td>
                                                    <td class="text-left py-2 tbl2-data">{{ item.curp }}</td>
                                                    <td class="text-center py-2 tbl2-data">{{ item.c_baja ? item.c_baja : '---' }}</td>
                                                </tr>
                                            </template>

                                        </tbody>
                                    </table>
                                </v-col>

                                <v-col
                                    cols="12" xs="12" sm="12" md="12"
                                    class="px-5 py-2 border-tabla2"
                                    style="min-width: 700px;"
                                    v-if="showTable == 'todos' || showTable == 'rechazados'"
                                >
                                    <table class="tbl-collapse tbl2">
                                        <thead>
                                            <tr class="pa-0 ma-0">
                                                <th colspan="13" class="tbl2-title py-2" style="border-top-left-radius: 15px; border-top-right-radius: 15px; border-bottom: 1px solid #E0E0E0;">
                                                    Movimientos rechazados
                                                </th>
                                            </tr>
                                            <tr class="pa-0 ma-0">
                                                <th class="tbl2-subtitle">
                                                    #T.Mov.
                                                </th>
                                                <th class="tbl2-subtitle text-left">
                                                    NSS
                                                </th>
                                                <th class="tbl2-subtitle text-left">
                                                    Nombre
                                                </th>
                                                <th class="tbl2-subtitle">
                                                    Causa del rechazo
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="itemsMovimientosRechazados.length == 0">
                                                <tr>
                                                    <td colspan="13" class="text-center py-5 tbl2-data">No hay datos disponibles</td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr :key="item.id" v-for="item in itemsMovimientosRechazados">
                                                    <td class="text-center py-2 tbl2-data">{{ item.tipo_movimiento_clave }}</td>
                                                    <td class="text-left py-2 tbl2-data">{{ item.nss }}</td>
                                                    <td class="text-left py-2 tbl2-data">{{ item.nombre + ' ' + item.apellido_paterno + ' ' + item.apellido_materno }}</td>

                                                    <td class="text-center py-2 tbl2-data">{{ item.causa_rechazo ? item.causa_rechazo : '---' }}</td>
                                                </tr>
                                            </template>

                                        </tbody>
                                    </table>
                                </v-col>
                            </v-row>

                        </template>
                    </div>
                </v-col>
            </v-row>
        </v-container>


    </div>
</template>

<script>
import BtnAcciones from '@/components/BtnAcciones.vue';
import Notify from '@/plugins/notify';
import clienteApi from '@/api/clientes';
import apiRegistroPatronal from "@/api/nominas/registroPatronal";
import apiSeguridadSocial from "@/api/nominas/seguridadSocial";
import lotes from '../../js/lotes.js';
import datos from '../../js/datos.js';

export default {
    components: {
        BtnAcciones,
    },
    data() {
        return {
            url         : "catalogo-sat/clases/find",
            columns     : [
                {
                    label: 'Registro Patronal',
                    name: 'registro_patronal',
                    filterable: true
                },
                {
                    label: 'Clave empleado',
                    name: 'clave_empleado',
                    filterable: true
                },
                {
                    label: 'Nombre',
                    name: 'nombre',
                    filterable: true
                },
                {
                    label: 'Apellido paterno',
                    name: 'apellido_paterno',
                    filterable: false
                },
                {
                    label: 'Apellido materno',
                    name: 'apellido_materno',
                    filterable: false
                },
                {
                    label: 'NSS',
                    name: 'nss',
                    filterable: false
                },
                {
                    label: 'SBC',
                    name: 'sbc',
                    filterable: false
                },
                {
                    label: 'Fecha de movimiento',
                    name: 'fecha_movimiento',
                    filterable: false
                },
                {
                    label: 'CURP',
                    name: 'curp',
                    filterable: false
                },
                {
                    label: 'UMF',
                    name: 'umf',
                    filterable: false
                },
                {
                    label: 'Tipo trabajador',
                    name: 'tipo_trabajador',
                    filterable: false
                },
                {
                    label: 'Tipo salario',
                    name: 'tipo_salario',
                    filterable: false
                },
                {
                    label: 'Jornada reducida',
                    name: 'jornada_reducida',
                    filterable: false
                },
                {
                    label: 'Estado',
                    name: 'estado',
                    filterable: false
                },
                {
                    label: 'Fecha de envío',
                    name: 'fecha_envio',
                    filterable: false
                },
                {
                    label: 'Acuse recibido',
                    name: 'acuse_recibido',
                    filterable: false
                },
                {
                    label: 'Acuse operado',
                    name: 'acuse_operado',
                    filterable: false
                },
                {
                    label: 'Acuse de rechazo',
                    name: 'acuse_rechazo',
                    filterable: false
                },
                {
                    label: 'Causa de rechazo',
                    name: 'causa_rechazo',
                    filterable: false
                },
            ],
            filters     : {
                activo    :true,
                paginate  :true,
                order     :"asc"
            },
            datosLogin      : null,
            rol             : null,
            userData        : this.$session.get('usuario'),
            accion          : null,
            tituloModal     : null,
            imagen          : "",
            dialog          : false,
            isLoading       : false,
            isSaving        : false,
            masivo          : false,
            dataFake        : [],
            btnLotes        : '',
            showTabla       : false,
            frase           : "Descargando archivo",
            overlayDesgarga : false,

            cliente_value   : null,
            clientes        : [],
            itemsRegistrosPatronales: [],
            registro_patronal_value : null,
            itemsLotes      : [],
            lote_value      : null,
            datosLote       : {
                activo: true,
                bajas_aceptados: 0,
                bajas_rechazados: 0,
                bajas_totales: 0,
                estatus: "",
                fecha: "",
                id: 0,
                mod_salario_aceptados: 0,
                mod_salario_rechazados: 0,
                mod_salario_totales: 0,
                movimientos: [],
                numero_lote: "",
                registro_patronal_id: 0,
                reingresos_aceptados: 0,
                reingresos_rechazados: 0,
                reingresos_totales: 0,
                tipo_lote: "",
                url_acuse: null,
                url_constancias: null,
                url_respuesta: null,
            },
            itemsMovimientos: [],
            itemsMovimientosAceptados: [],
            itemsMovimientosRechazados: [],
            showTable:"todos",
            datosRegistroPatronal : {
                rfc: "",
                nombre: "",
            }
        }
    },
    watch: {
        cliente_value: function(val) {
            this.registro_patronal_value = null
            if(val != null) {
                this.getRegistrosPatronales();
            }
        },
        registro_patronal_value: function(val) {
            this.lote_value = null
            if(val != null) {
                this.getLotes(1);
            }
            else {
                this.itemsLotes = [];
            }
        },
        btnLotes: function(val) {
            if(val == 'btn1') {
                this.itemsMovimientos = this.datosLote.movimientos;
                this.itemsMovimientosAceptados = this.datosLote.movimientos.filter(item => item.estado == 'PROCESADO');
                this.itemsMovimientosRechazados = this.datosLote.movimientos.filter(item => item.estado == 'RECHAZADO');
                this.showTable = "todos";
                this.masivo = this.itemsMovimientos.length > 0 ? true : false;
            }
            else if(val == 'btn2') {
                this.itemsMovimientosAceptados = this.datosLote.movimientos.filter(item => item.estado == 'PROCESADO');
                this.showTable = "aceptados";
                this.masivo = this.itemsMovimientos.length > 0 ? true : false;
            }
            else if(val == 'btn3') {
                this.itemsMovimientosRechazados = this.datosLote.movimientos.filter(item => item.estado == 'RECHAZADO');
                this.showTable = "rechazados";
                this.masivo = this.itemsMovimientos.length > 0 ? true : false;
            }
            // else if(val == 'btn4') {
            //     this.itemsMovimientos = this.datosLote.movimientos.filter(item => item.estado == 'ENVIADO');
            //     this.masivo = this.itemsMovimientos.length > 0 ? true : false;
            // }
        },
    },
    methods: {
        exportar(tipo = 'txt'){

        },
        generarReporte(tipo = 'xlsx'){

        },
        abrirModalBuscar(){
        },
        filtroLotes(btn = 'btn1'){
            this.btnLotes = btn;
        },
        getClientes(cliente = null) {
            let param = { activo: true, paginate: false }
            clienteApi.getClientes(param).then((response) => {
                this.clientes = response.data;
            })
            .catch(error => {
                this.resetValue();
                Notify.ErrorToast(error.response.data.error);
            });
        },

        async getRegistrosPatronales() {
            if(this.cliente_value == null){
                return;
            }

            let param = {
                activo: true,
                paginate: false,
                cliente_id: this.cliente_value
            };
            this.itemsRegistrosPatronales = [];
            await apiRegistroPatronal.find(param).then(response => {
                let format = response.data;
                if(response.data.length != 0){
                    format.forEach( item => {
                        item.nombreClave = item.nombre + ' - ' + item.clave
                        this.itemsRegistrosPatronales.push(item);
                    })
                }
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los registros patronales.");
            });

        },
        async getLotes(pagina = 1) {
            if(this.registro_patronal_value == null){
                return;
            }

            let param = {
                activo: true,
                paginate: true,
                page: pagina,
                per_page: 10,
                registro_patronal_id: this.registro_patronal_value
            };
            this.itemsLotes = [];
            await apiSeguridadSocial.getLotes(param).then(async response => {
                await response.data.forEach(item => {
                    item.loteFecha = item.numero_lote + " - " + this.dateFormat(item.fecha, 'modal') + " - " + item.tipo_lote;

                    this.itemsLotes.push(item)
                })
            })
            .catch(err => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los lotes.");
            });
        },
        async obtenerDatos(){
            this.showTabla = true;
            this.btnLotes = 'btn1';
            this.datosLote = await this.itemsLotes.find(item => item.id == this.lote_value);
            this.datosRegistroPatronal = await this.itemsRegistrosPatronales.find(item => item.id == this.registro_patronal_value);


            this.itemsMovimientos = this.datosLote.movimientos;
            this.itemsMovimientosAceptados = this.datosLote.movimientos.filter(item => item.estado == 'PROCESADO');
            this.itemsMovimientosRechazados = this.datosLote.movimientos.filter(item => item.estado == 'RECHAZADO');
            this.showTable = "todos";
            this.masivo = this.itemsMovimientos.length > 0 ? true : false;
        },

        descargaConstancia(item, procesamiento = 'INDIVIDUAL') {
            const FileDownload = require("js-file-download");
            const axios = require("axios");
            let url = "seguridad-social/lotes/consulta-constancia";
            let nombre = "Constancias.zip";
            this.frase = "Descargando archivo";
            this.overlayDesgarga = true;


            let parametros = {
                lote_id: null,
                movimientos_ids: [],
                procesamiento: procesamiento,
                tipo: 'CONSULTA'
            }

            if(procesamiento == 'INDIVIDUAL') {
                parametros.lote_id = item.lote_id;
                parametros.movimientos_ids.push(item.id);
                nombre = `CONSTANCIA_${item.nombre}_${item.apellido_paterno ? item.apellido_paterno : ''}_${item.apellido_materno ? item.apellido_materno : ''}.zip`;
            }
            else {
                parametros.lote_id = this.datosLote.id;
                nombre = `CONSTANCIAS_LOTE_${this.datosLote.numero_lote}.zip`;
                this.itemsMovimientos.forEach(mov => {
                    parametros.movimientos_ids.push(mov.id);
                });
                procesamiento = 'INDIVIDUAL';
            }

            try {
                axios({
                    method: "post",
                    url: url,
                    responseType: "blob",
                    data: parametros,
                }).then(function(response) {
                    FileDownload(response.data, nombre);
                });
            } catch (error) {
                console.log(error);
            }finally {
                this.overlayDesgarga = false;
            }

        },
        descargaAcuse(){

            const FileDownload = require("js-file-download");
            const axios = require("axios");
            let url = "seguridad-social/lotes/consulta-acuse";
            let nombre = `ACUSE_LOTE_${this.datosLote.numero_lote}.pdf`;
            this.frase = "Descargando archivo";
            this.overlayDesgarga = true;


            let parametros = {
                lote_id: this.datosLote.id,
                tipo: 'CONSULTA'
            }
            try {
                axios({
                    method: "post",
                    url: url,
                    responseType: "blob",
                    data: parametros,
                }).then(function(response) {
                    FileDownload(response.data, nombre);
                });
            } catch (error) {
                console.log(error);
            }finally {
                this.overlayDesgarga = false;
            }
        },
        descargaRespuesta(){
            const FileDownload = require("js-file-download");
            const axios = require("axios");
            let url = "seguridad-social/lotes/consulta-respuesta";
            let nombre = `RESPUESTA_LOTE_${this.datosLote.numero_lote}.pdf`;
            this.frase = "Descargando archivo";
            this.overlayDesgarga = true;

            let parametros = {
                lote_id: this.datosLote.id,
                tipo: 'CONSULTA'
            }


            try {
                axios({
                    method: "post",
                    url: url,
                    responseType: "blob",
                    data: parametros
                }).then(function(response) {
                    FileDownload(response.data, nombre);
                });
            } catch (error) {
                console.log(error);
            }finally {
                this.overlayDesgarga = false;
            }
        },

        descarga(tipoDocumento){
            const FileDownload = require("js-file-download");
            const axios = require("axios");

            let url = "seguridad-social/lotes/reporte";
            let nombre = ``;
            let tipo = '';
            if(tipoDocumento == 'ACUSE_RECIBIDO'){
                nombre = `ACUSE_RECIBIDO_LOTE_${this.datosLote.numero_lote}.pdf`;
                tipo = 'acuse';
            }
            else if(tipoDocumento == 'ACUSE_ACEPTADO'){
                nombre = `ACUSE_ACEPTADO_LOTE_${this.datosLote.numero_lote}.pdf`;
                tipo = 'respuesta';
            }
            else if(tipoDocumento == 'EXCEL'){
                nombre = `REPORTE_LOTE_${this.datosLote.numero_lote}.xlsx`;
                tipo = 'reporte';
            }


            this.frase = "Descargando archivo";
            this.overlayDesgarga = true;

            let parametros = {
                registro_id: this.datosLote.id,
                archivo: tipo,
                tipo: 'lote'
            }


            try {
                axios({
                    method: "post",
                    url: url,
                    responseType: "blob",
                    data: parametros
                }).then(function(response) {
                    FileDownload(response.data, nombre);
                });
            } catch (error) {
                console.log(error);
            }finally {
                this.overlayDesgarga = false;
            }
        },

        /**
         * @method dateFormat Esta método parsea una fecha
         * @description Convierte una fecha de formato AAAA-MM-DD => DD/MM/AAAA. Se usa para el modal y la tabla
         * @param {string} fecha formato AAAA-MM-DD
         * @param {string} tipo string con valor 'modal' o 'tabla'
         * @return {string} devuelve un string en formato DD/MM/AAAA
        */
        dateFormat(fecha, tipo) {
            if(fecha == null){
                return;
            }
            else{
                let fecha2 = fecha.split("-");
                if(tipo == 'modal'){
                    return fecha2[2] + "/" + fecha2[1]+ "/" + fecha2[0];
                }else{
                    return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
                }
            }

        },
    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;

        if(this.rol == 'root') {
            this.getClientes();
        }
        else {
            this.cliente_value = this.datosLogin.cliente_id
        }

    },
    mounted(){
        this.dataFake = lotes
    },
    updated(){
    }
}
</script>

<style scoped>
    .div-card {
        background-color: #fdfcfc;
        border-radius: 20px;
    }
    div.btnAccionesItem {
        width: 100%;
        cursor: pointer;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.btnAccionesItem span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    div.btnAccionesItem:hover {
        background: #F6F6F8;
    }
    .deshabilitado{
        background:#fcf6f6;
        cursor:not-allowed;

        width: 100%;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.deshabilitado:hover{
        background:#f2f2f2;
        cursor:not-allowed;

        width: 100%;
        outline: 0;
        padding-left: 30px;
        padding-right: 30px;
    }
    div.deshabilitado span {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
        color: #828282;
    }
    .v-btn-excel::before {
        background-color: transparent;
    }
    .btn-lotes {
        background-color: #E4E4E5;
        height: 2.1875rem;
        border-radius: 8px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;
    }
    .btn-activo {
        color: #444975;
    }
    .btn-inactivo {
        color: #828282;
    }

    .tbl-collapse {
        border-spacing: 0;
        width: 100%;
        overflow-x: scroll;
        overflow-y: scroll;
    }

    .border-tabla1 {
        border-width:1px;
        border-color:#E0E0E0 ;
        border-style: solid;
        border-radius: 15px;
    }

    .border-left {
        border-width:1px;
        border-color:#E0E0E0 ;
        border-left-style: solid;
    }

    .tbl1-title {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        color: #828282;
        text-align: left;
    }
    .tbl1-subtitle {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: #4F4F4F;
        text-align: left;
    }

    .tbl2 {
        -moz-border-radius:15px;
        -webkit-border-radius:15px;
        border-radius:15px;
        border: 1px solid #E0E0E0;
    }

    .tbl2-title {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        color: #828282;
        text-align: center;
        background-color: #F2F2F2;
    }
    .tbl2-subtitle {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        color: #828282;
        text-align: center;
        background-color: #F6F6F6;
        padding: 8px 0;
    }

    .tbl2-data {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        color: #1D1B20;
    }


</style>
